const CURRENCY_NAMES = {
  USD: "US Dollars", AUD: "Australian Dollars", INR: "Indian Rupees",
  EUR: "Euros", GBP: "Pounds Sterling", AED: "UAE Dirhams", SGD: "Singapore Dollars",
};

const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function threeDigits(n) {
  let s = "";
  if (n >= 100) { s += ONES[Math.floor(n / 100)] + " Hundred "; n %= 100; }
  if (n >= 20) { s += TENS[Math.floor(n / 10)] + " "; n %= 10; }
  if (n > 0) s += ONES[n] + " ";
  return s.trim();
}

export function numberToWords(num) {
  num = Math.floor(Math.abs(Number(num) || 0));
  if (num === 0) return "Zero";
  const parts = [];
  const scales = [[1e9, "Billion"], [1e6, "Million"], [1e3, "Thousand"], [1, ""]];
  for (const [val, name] of scales) {
    if (num >= val) {
      const chunk = Math.floor(num / val);
      parts.push(threeDigits(chunk) + (name ? " " + name : ""));
      num %= val;
    }
  }
  return parts.join(" ").replace(/\s+/g, " ").trim();
}

const money = (v, cur) => `${cur} ${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

function pageHTML(inv, copyLabel, origin) {
  const cur = inv.currency || "USD";
  const fob = inv.fob ?? (inv.items || []).reduce((s, i) => s + Number(i.amount || 0), 0);
  const total = inv.total ?? (fob + Number(inv.freight || 0) + Number(inv.insurance || 0));
  const rows = (inv.items || []).map((it, i) => `
    <tr><td>${i + 1}</td><td>${esc(it.description)}</td><td>${esc(it.hs_code)}</td>
    <td class="num">${esc(it.qty)}</td><td class="num">${Number(it.rate || 0).toFixed(2)}</td>
    <td class="num">${Number(it.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</td></tr>`).join("");
  const words = `${CURRENCY_NAMES[cur] || cur} ${numberToWords(total)} Only.`;
  return `
  <div class="page">
    <div class="copytag">${copyLabel}</div>
    <img class="watermark" src="${origin}/vns-logo.png" alt="" />
    <header>
      <img src="${origin}/vns-logo.png" alt="VNS" />
      <div class="co">
        <h1>${esc(inv.exporter_name || "VNS Vinayaka Group of Enterprises")}</h1>
        <div class="sub">Exporters &amp; Trading Division</div>
        <div class="addr">${esc(inv.exporter_address)}<br/>
        ${inv.exporter_gstin ? "GSTIN: " + esc(inv.exporter_gstin) + " · " : ""}${inv.exporter_iec ? "IEC: " + esc(inv.exporter_iec) + " · " : ""}${inv.exporter_pan ? "PAN: " + esc(inv.exporter_pan) : ""}</div>
      </div>
    </header>
    <div class="title">Commercial Invoice</div>
    <table class="grid">
      <tr>
        <td style="width:50%"><span class="lbl">Exporter / Seller</span><span class="val"><b>${esc(inv.exporter_name)}</b><br/>${esc(inv.exporter_address)}</span></td>
        <td style="width:25%"><span class="lbl">Invoice No.</span><span class="val">${esc(inv.number)}</span></td>
        <td style="width:25%"><span class="lbl">Invoice Date</span><span class="val">${esc(inv.date)}</span></td>
      </tr>
      <tr>
        <td rowspan="2"><span class="lbl">Consignee / Buyer</span><span class="val"><b>${esc(inv.consignee_name)}</b><br/>${esc(inv.consignee_address).replace(/\n/g, "<br/>")}${inv.consignee_ref ? "<br/>" + esc(inv.consignee_ref) : ""}</span></td>
        <td><span class="lbl">Buyer's Order No.</span><span class="val">${esc(inv.order_no)}</span></td>
        <td><span class="lbl">Order Date</span><span class="val">${esc(inv.order_date)}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Payment Terms</span><span class="val">${esc(inv.payment_terms)}</span></td>
        <td><span class="lbl">Delivery Terms</span><span class="val">${esc(inv.delivery_terms)}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Pre-Carriage / Place of Receipt</span><span class="val">${esc(inv.pre_carriage)}</span></td>
        <td><span class="lbl">Vessel / Voyage No.</span><span class="val">${esc(inv.vessel)}</span></td>
        <td><span class="lbl">Mode</span><span class="val">${esc(inv.mode)}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Port of Loading</span><span class="val">${esc(inv.port_loading)}</span></td>
        <td><span class="lbl">Port of Discharge</span><span class="val">${esc(inv.port_discharge)}</span></td>
        <td><span class="lbl">Final Destination</span><span class="val">${esc(inv.final_destination)}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Container / Seal No.</span><span class="val">${esc(inv.container_seal)}</span></td>
        <td><span class="lbl">Marks &amp; Nos.</span><span class="val">${esc(inv.marks)}</span></td>
        <td><span class="lbl">Country of Origin</span><span class="val">${esc(inv.country_origin)}</span></td>
      </tr>
    </table>
    <table class="items">
      <thead><tr>
        <th style="width:34px">Sr.</th><th>Description of Goods</th><th style="width:70px">HS Code</th>
        <th class="num" style="width:80px">Qty</th><th class="num" style="width:90px">Rate (${cur})</th><th class="num" style="width:110px">Amount (${cur})</th>
      </tr></thead>
      <tbody>${rows}<tr><td colspan="6" style="height:6px;border-left:1px solid var(--line);border-right:1px solid var(--line)"></td></tr></tbody>
    </table>
    <table class="totals">
      <tr><td>FOB Value</td><td class="num">${money(fob, cur)}</td></tr>
      <tr><td>Add: Ocean Freight</td><td class="num">${money(inv.freight, cur)}</td></tr>
      <tr><td>Add: Marine Insurance</td><td class="num">${money(inv.insurance, cur)}</td></tr>
      <tr class="grand"><td>Total ${esc(inv.delivery_terms) || "Invoice Value"}</td><td class="num">${money(total, cur)}</td></tr>
    </table>
    <div class="words"><b>Amount in words:</b> ${esc(words)}<br/>
    <b>Packing:</b> ${esc(inv.packing) || "—"} · <b>Net Wt:</b> ${esc(inv.net_weight) || "—"} · <b>Gross Wt:</b> ${esc(inv.gross_weight) || "—"}</div>
    <div class="foot">
      <div class="bank"><b>Bank Details (for remittance)</b><br/>
        ${inv.bank_beneficiary ? "Beneficiary: " + esc(inv.bank_beneficiary) + "<br/>" : ""}
        ${inv.bank_name ? "Bank: " + esc(inv.bank_name) + "<br/>" : ""}
        ${inv.bank_account ? "A/C No.: " + esc(inv.bank_account) + "<br/>" : ""}
        ${inv.bank_ifsc ? "IFSC: " + esc(inv.bank_ifsc) + " · " : ""}${inv.bank_swift ? "SWIFT: " + esc(inv.bank_swift) : ""}
        ${inv.bank_ad_code ? "<br/>AD Code: " + esc(inv.bank_ad_code) : ""}
      </div>
      <div class="decl"><b>Declaration</b><br/>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
        <div class="sign">
          <div><img class="stamp" src="${origin}/vns-stamp.png" alt="stamp"/></div>
          <div style="text-align:center"><img class="sig" src="${origin}/vns-signature.png" alt="signature"/>
          <div class="line">For ${esc(inv.exporter_name || "VNS Vinayaka")}<br/>Authorised Signatory</div></div>
        </div>
      </div>
    </div>
    <div class="bar">${copyLabel} · VNS Vinayaka Group of Enterprises</div>
    ${inv.notes ? `<div class="note">${esc(inv.notes)}</div>` : ""}
  </div>`;
}

const STYLE = `
  :root{--navy:#0B2545;--gold:#C5A059;--ink:#0f172a;--line:#c7cdd6;--soft:#f4f6f9;}
  *{box-sizing:border-box;}
  body{margin:0;background:#e9edf2;font-family:Georgia,'Times New Roman',serif;color:var(--ink);}
  .toolbar{position:sticky;top:0;background:#0B2545;color:#fff;padding:10px 16px;font-family:Arial,sans-serif;display:flex;gap:10px;align-items:center;z-index:5;}
  .toolbar button{background:#C5A059;color:#0B2545;border:0;padding:8px 16px;border-radius:6px;font-weight:700;cursor:pointer;}
  .page{width:210mm;min-height:297mm;background:#fff;margin:16px auto;padding:14mm 12mm;box-shadow:0 6px 24px rgba(0,0,0,.15);position:relative;}
  .copytag{position:absolute;top:14mm;right:12mm;max-width:150px;border:2px solid var(--navy);color:var(--navy);font-family:Arial,sans-serif;font-weight:700;font-size:9.5px;letter-spacing:.5px;line-height:1.2;padding:4px 8px;border-radius:4px;text-transform:uppercase;text-align:center;white-space:normal;}
  .watermark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:120mm;max-width:70%;opacity:.06;pointer-events:none;}
  header{display:flex;align-items:center;gap:16px;border-bottom:3px solid var(--gold);padding-bottom:10px;padding-right:175px;}
  header img{height:66px;width:66px;object-fit:contain;}
  .co h1{margin:0;font-size:19px;color:var(--navy);letter-spacing:.3px;}
  .co .sub{font-family:Arial,sans-serif;font-size:10px;letter-spacing:3px;color:#64748b;text-transform:uppercase;}
  .co .addr{font-family:Arial,sans-serif;font-size:11px;color:#475569;margin-top:4px;line-height:1.4;}
  .title{text-align:center;font-family:Arial,sans-serif;font-weight:700;font-size:15px;letter-spacing:3px;color:var(--navy);margin:12px 0 6px;text-transform:uppercase;}
  table{width:100%;border-collapse:collapse;}
  .grid td{border:1px solid var(--line);vertical-align:top;padding:6px 8px;font-family:Arial,sans-serif;font-size:11px;}
  .lbl{font-size:8.5px;letter-spacing:.5px;text-transform:uppercase;color:#64748b;display:block;margin-bottom:2px;}
  .val{font-size:11.5px;color:var(--ink);}
  .items{margin-top:8px;}
  .items th{background:var(--navy);color:#fff;font-family:Arial,sans-serif;font-size:10px;letter-spacing:.5px;padding:7px 8px;text-align:left;text-transform:uppercase;}
  .items td{border:1px solid var(--line);padding:7px 8px;font-family:Arial,sans-serif;font-size:11px;}
  .items td.num,.items th.num{text-align:right;}
  .items tr:nth-child(even) td{background:var(--soft);}
  .totals{width:52%;margin-left:auto;margin-top:8px;}
  .totals td{padding:5px 8px;font-family:Arial,sans-serif;font-size:11.5px;border:1px solid var(--line);}
  .totals .grand td{background:var(--gold);color:var(--navy);font-weight:700;font-size:13px;}
  .words{font-family:Arial,sans-serif;font-size:11px;margin-top:8px;padding:7px 8px;background:var(--soft);border:1px solid var(--line);}
  .foot{display:flex;gap:14px;margin-top:10px;}
  .bank{flex:1;border:1px solid var(--line);padding:8px;font-family:Arial,sans-serif;font-size:10.5px;line-height:1.5;}
  .decl{flex:1;border:1px solid var(--line);padding:8px;font-family:Arial,sans-serif;font-size:10.5px;position:relative;}
  .sign{display:flex;justify-content:space-between;align-items:flex-end;margin-top:26px;}
  .sign .stamp{height:70px;}
  .sign .sig{height:38px;margin-bottom:2px;}
  .sign .line{border-top:1px solid #334155;padding-top:3px;font-size:10px;color:#334155;width:150px;text-align:center;}
  .note{font-family:Arial,sans-serif;font-size:9.5px;color:#64748b;text-align:center;margin-top:8px;}
  .bar{background:var(--navy);color:var(--gold);text-align:center;font-family:Arial,sans-serif;font-size:9.5px;letter-spacing:1px;padding:5px;margin-top:8px;border-radius:3px;}
  @media print{body{background:#fff;} .toolbar{display:none;} .page{box-shadow:none;margin:0;page-break-after:always;}}
`;

export function openInvoicePrint(inv) {
  const origin = window.location.origin;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${inv.number || "Invoice"} · VNS Vinayaka</title><style>${STYLE}</style></head>
  <body>
    <div class="toolbar"><b>${inv.number || "Invoice"}</b><span style="flex:1"></span><button onclick="window.print()">🖨 Print / Save as PDF</button></div>
    ${pageHTML(inv, "ORIGINAL — FOR CUSTOMER / BUYER", origin)}
    ${pageHTML(inv, "DUPLICATE — FOR SELLER", origin)}
    ${pageHTML(inv, "TRIPLICATE — FOR TRANSPORT / ACCOUNTS / RECORDS", origin)}
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
